import React from 'react';
import Article from '../../components/article/Article';
import { blog01, blog02, blog03, blog04, blog05 } from './imports';
import './blog.css';

const Blog = () => (
  <div className="yellow__blog section__padding" id="blog">
    <div className="yellow__blog-heading">
      <h1 className="gradient__text">A lot is happening,We are blogging about it.</h1>
    </div>
    <div className="yellow__blog-container">
      <div className="yellow__blog-container_groupA">
        <Article imgUrl={blog01} date="Sep 26, 2021" text="Innovation for people.Better for the environment?" />
      </div>
      <div className="yellow__blog-container_groupB">
        <Article imgUrl={blog02} date="Sep 26, 2021" text="Yellowaste is the future. Let us explore how it is?" />
        <Article imgUrl={blog03} date="Mar 22, 2022" text="On-demand recycling.How it makes things better?" />
        <Article imgUrl={blog04} date="Jul 14, 2022" text="Impact-based innovation.Better community-based innovation?" />
        <Article imgUrl={blog05} date="May 7, 2024" text="A platform to unify all. A place for everthing recycling?" />
      </div>
    </div>
  </div>
);

export default Blog;